import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
    SoftwareMasterCreateRequestDTO,
    SoftwareMasterDeleteRequestDTO,
    SoftwareMasterGetDictionaryRequestDTO,
    SoftwareMasterList,
    SoftwareMasterReadByIdRequestDTO,
    SoftwareMasterReadByUserIdRequestDTO,
    SoftwareMasterUpdateRequestDTO
} from "./software-master.interface";
import {
    SoftwareMaster_create,
    SoftwareMaster_delete,
    SoftwareMaster_GetDictionary,
    SoftwareMaster_readAll,
    SoftwareMaster_readById,
    SoftwareMaster_readByUserId,
    SoftwareMaster_update
} from "src/app/GlobalVariables";
import { GetDictionaryList } from "src/app/Common/common.interface";


@Injectable({
    providedIn: 'root'
})

export class SoftwareMasterService {

    constructor() { }

    http = inject(HttpClient);


    SoftwareMaster_create(data: SoftwareMasterCreateRequestDTO): Observable<SoftwareMasterCreateRequestDTO> {
        return this.http.post<SoftwareMasterCreateRequestDTO>(SoftwareMaster_create, data)
    }

    SoftwareMaster_update(data: SoftwareMasterUpdateRequestDTO): Observable<SoftwareMasterUpdateRequestDTO> {
        return this.http.post<SoftwareMasterUpdateRequestDTO>(SoftwareMaster_update, data)
    }

    SoftwareMaster_delete(data: SoftwareMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SoftwareMaster_delete, data)
    }

    SoftwareMaster_ReadById(data: SoftwareMasterReadByIdRequestDTO): Observable<SoftwareMasterList> {
        return this.http.post<SoftwareMasterList>(SoftwareMaster_readById, data);
    }

    SoftwareMaster_readAll(): Observable<SoftwareMasterList> {
        return this.http.get<SoftwareMasterList>(SoftwareMaster_readAll);
    }

    SoftwareMaster_ReadByUserId(data: SoftwareMasterReadByUserIdRequestDTO): Observable<SoftwareMasterList> {
        return this.http.post<SoftwareMasterList>(SoftwareMaster_readByUserId, data);
    }

    SoftwareMaster_GetDictionary(data: SoftwareMasterGetDictionaryRequestDTO): Observable<GetDictionaryList> {
        return this.http.post<GetDictionaryList>(SoftwareMaster_GetDictionary, data);
      }
}